import { api, apiUrl } from "./client";

export interface BrandAsset {
  id: string; slot: string; version: number; filename: string; content_type: string; size: number; original_size: number;
  width: number; height: number; resized: boolean; sha256: string; is_current: boolean; uploaded_by: string; uploaded_at: string;
}
export interface BrandSlot {
  slot: string; label: string; help: string | null; max_mb: number; max_dim: number; accepted: string[]; current: BrandAsset | null; versions: BrandAsset[];
}

export const brandApi = {
  list: () => api.get<{ slots: BrandSlot[] }>("/admin/brand-assets"),
  upload: (slot: string, file: File) => {
    const form = new FormData();
    form.append("file", file);
    return api.post<BrandAsset>(`/admin/brand-assets/${slot}`, form);
  },
  fileUrl: (slot: string, version: number, download = false) =>
    apiUrl(`/admin/brand-assets/${slot}/file?version=${version}${download ? "&download=true" : ""}`),
};

export const PUBLIC_BRAND = `${process.env.REACT_APP_BACKEND_URL ?? ""}/api/public/brand`;
export type BrandStatus = Record<string, boolean> & { logo_version?: string | null };
let statusReq: Promise<BrandStatus> | null = null;
// One shared check per page load, so absent assets never trigger a failing image request.
export const publicBrandStatus = (fresh = false) => {
  if (fresh) statusReq = null;
  return (statusReq ??= fetch(`${PUBLIC_BRAND}/status`).then((r) => (r.ok ? r.json() : {})).catch(() => ({})) as Promise<BrandStatus>);
};
